import { HTMLAttributes } from 'vue';

export type apexChartTypes = 'line' | 'scatter' | 'rangeArea';

export interface GetChartOptionsParamType {
  type: apexChartTypes;
  colors: string[];
  fillOpacity: number[];
  strokeWidth: number[];
  markersSize: number[];
  inverseOrder?: boolean;
  tooltipEnable?: boolean;
  hideCustomToolTip?: boolean;
  annotationRange?: any[];
  annotationFill?: string;
  showLegend?: boolean;
  axisLabels?: { x: string; y: string };
}

export enum GraphDataNamesEnum {
  ANOMALY = 'anomaly',
  SEVERITY = 'sev',
  MINOR_BREACH = 'minor',
  MAJOR_BREACH = 'major',
  CRITICAL_BREACH = 'critical',
  UPPER_THRESHOLD = 'ut',
  LOWER_THRESHOLD = 'lt',
  GROUND_TRUTH = 'gt',
  FORECAST_VALUE = 'fv',
  TIMESTAMPS = 'time',
  NO_BREACH = 'no breach'
}

export enum GraphTypesEnum {
  FORECAST_CHART = 'forecast',
  FORECAST_WITH_ANOMALY = 'forecast_with_anomaly',
  LINE_CHART = 'linechart',
  LINE_CHART_LABELLED = 'linechart_labelled',
}

export type GraphTypes =
  | GraphTypesEnum.FORECAST_CHART
  | GraphTypesEnum.FORECAST_WITH_ANOMALY
  | GraphTypesEnum.LINE_CHART
  | GraphTypesEnum.LINE_CHART_LABELLED;

export type ChartTypes = ChartTypesEnum.LINE | ChartTypesEnum.RANGE_AREA;

export interface AnomalyDataObjectType {
  x: string;
  y: number | null;
  date?: string;
  sevKey?:
    | GraphDataNamesEnum.CRITICAL_BREACH
    | GraphDataNamesEnum.MAJOR_BREACH
    | GraphDataNamesEnum.MINOR_BREACH;
  type?: string;
  [GraphDataNamesEnum.SEVERITY]: 1 | 2 | 3;
  [GraphDataNamesEnum.UPPER_THRESHOLD]: number;
  [GraphDataNamesEnum.LOWER_THRESHOLD]: number;
}

export interface LegendInfoType {
  color: string;
  isActive: boolean;
  label: string;
  key: GraphDataNamesEnum;
  type: 'circle' | 'line';
}

export enum ChartTypesEnum {
  LINE = 'line',
  RANGE_AREA = 'rangeArea',
}

export interface ConditionType {
  name: string;
  entity: object;
}

export interface ParamsType {
  condition: ConditionType;
  duration: object;
  labels?: [];
}

export interface InfoStylingType {
  enabled: boolean;
  styles: { style: HTMLAttributes };
}

export interface HeaderType {
  title?: String;
  titleIcon?: String;
  content?: [];
  isError?: boolean;
  displayCustomButton?: boolean;
  subIconTitle?: String;
  customButtonProp?: {
    routeName: String;
    routeParams: boolean;
    key: String;
    title: String;
  };
  titleSuffixIcon?: String;
  HideCenterMiscContent?: boolean;
  titlePrefixIcon?: String;
  displayOnlyUnit?: boolean;
  basicInfoStyling?: InfoStylingType;
  hidePercentageParam?: boolean;
  unit?: String;
  showAnomaly?: boolean;
}

export interface HeaderValuesType {
  total: number;
  avg: number;
  perMin: number;
  anomalies: number;
}

export interface Aggregation {
  req: false;
  type?: String;
  val?: Number;
}

export interface ConfigType {
  title: String;
  width: String;
  entityType: String;
  metricName: String;
  axisLabelsY: String;
  header: HeaderType;
  chartColor: [];
  childQueries: [];
  chartType: String;
  unit: String;
  labelsY: String;
  aggregation: Aggregation;
}
